<template>
  <div class="container">
    <slot name="loadRequestsData" :loader="loader" />
  </div>
</template>

<script>
import dayjsru from "dayjs/locale/ru";
import dayjsen from "dayjs/locale/en";
import dayjstr from "dayjs/locale/tr";
import dayjses from "dayjs/locale/es";
import dayjsid from "dayjs/locale/id";
import cookie from "js-cookie";
import DatePicker from "vue2-datepicker";
import i18n from "@/helpers/i18n";
import choiseSelectTitleOnLoad from "@/helpers/selects";
import apiUser from "@/api/user";
import apiMimk from "@/api/master-classes/mimk";
import apiBooking from "@/api/master-classes/booking";
import { BACKOFFICE } from '@/services/HTTPService'

export default {
  data() {
    return {
      locales: {
        dayjsru,
        dayjsen,
        dayjstr,
        dayjses,
        dayjsid,
      },
      choiseSelectTitleOnLoad,
      loader: true,
      selectedLang: {},
    };
  },
  async created() {
    await this.getUserAndSegmentInfo();
    this.determinationLibrariesLocale();
    await this.requestsAndRedirectByRole();
    if (
      !cookie.get("authMimk") &&
      this.$store.state.user.user.role === "mimk"
    ) {
      try {
        this.$metrika.reachGoal("TCM_login_booking");
      } catch (err) {
        console.log(err);
      }
      cookie.set("authMimk", 1);
    }
    this.loader = false;
  },
  methods: {
    async getUserAndSegmentInfo() {
      try {
        await apiUser.userInfo();
        const selectedSegment = this.choiseSelectTitleOnLoad(
          "bookingSegment",
          this.$store.state.user.segmentsList
        );
        if (!selectedSegment || !selectedSegment.title) {
          console.error("Сегмент не найден, перенаправление на страницу 403");
          this.$router.push({ name: 'NotFound', query: { code: 403 } });
          return;
        }
        console.log("Выбранный сегмент:", selectedSegment);
        const extendSegmentInfo = await apiBooking.getSegmentInfo(selectedSegment.title);
        this.$store.commit("user/setSegment", extendSegmentInfo);
        const segmentInfo = await BACKOFFICE.get(`/segments/${selectedSegment.id}/`);
        this.$store.commit("user/setM1Distribution", segmentInfo.data.use_m1_booking_distribution);
      } catch (error) {
        console.error("Ошибка при получении информации о пользователе или сегменте: ", error);
        this.$router.push({ name: 'NotFound', query: { code: 403 } });
      }
    },
    determinationLibrariesLocale() {
      const selectedLang =
        this.choiseSelectTitleOnLoad(
          "bookingLang",
          this.$store.state.langs.langs
        ) || this.$store.state.langs.defaultLang;
      this.$store.commit("user/setLang", selectedLang);
      i18n.locale = selectedLang.id;
      DatePicker.locale(selectedLang.id);
      switch (selectedLang) {
        case "ru":
          this.$dayjs.locale(this.locales.dayjsru);
          break;
        case "en":
          this.$dayjs.locale(this.locales.dayjsen);
          break;
        case "tr":
          this.$dayjs.locale(this.locales.dayjstr);
          break;
        case "es":
          this.$dayjs.locale(this.locales.dayjses);
          break;
        case "id":
          this.$dayjs.locale(this.locales.dayjsid);
          break;
        default:
          this.$dayjs.locale(this.locales.dayjsen);
          break;
      }
    },
    async requestsAndRedirectByRole() {
      const role = cookie.get("role");
      const roleType = {
        isAdmin: role === "admin",
        isSupervisor: role === "supervisor",
        isMimk: role === "mimk",
        isManager: role === "manager",
      };
      if (roleType.isAdmin || roleType.isSupervisor) {
        apiMimk.getMimkStatus().then(listMimk => {
          this.$store.commit("user/setMimkList", listMimk)
        });
      }
      if (roleType.isAdmin || roleType.isMimk) {
        apiBooking.getRejectionReasons().then(rejectionReasons => {
          this.$store.commit("booking/setRejectionReasons", rejectionReasons);
        });
      }
      if (roleType.isMimk) {
        const mimkAwards = await apiMimk.getMimkAward();
        this.$store.commit("user/setMimkAward", mimkAwards);
      }
      if (roleType.isAdmin || roleType.isManager) {
        apiBooking.lossReasons().then((lossReasons) => {
          this.$store.commit("booking/setLossReasons", lossReasons);
        });

      }
      if (roleType.isAdmin || roleType.isManager) {
        apiBooking.firstConformation().then((firstConformation) => {
          this.$store.commit("booking/setFirstConformation", firstConformation);
        });

      }
      if (
        (this.$route.path === "/" && roleType.isAdmin) ||
        (this.$route.path === "/" && roleType.isManager)
      ) {
        this.$router.replace("/master-classes/manager/new-mk/");
        return;
      }
      if (this.$route.path === "/")
        this.$router.replace(`/master-classes/${role}/current-and-features/`);
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  display: flex;
}
.container-padding {
  padding-left: 235px;
}
.container {
  flex-grow: 1;
}
</style>
